<template>
  <div 
    v-if="show"
    class="modal-mask">
    <div class="modal-container">
      <slot/>
    </div>
  </div>
</template>


<script>

  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        showModal: false
      }
    },
    methods: {
      close() {
        this.$emit('close');
      }
    }
  }
</script>

<style scoped>
    .modal-mask {
      position: fixed;
      z-index: 9998;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow-y: auto;
    }
    .modal-container {
      width: 100%;
      height: 100%;
      overflow-y: auto;
      transition: all 1.3s;
    }
    .modal-enter {
      opacity: 0;
    }

    .modal-leave-active {
      opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
      transform: translate3d(100%, 0,0);
    }
</style>



// WEBPACK FOOTER //
// client/components/CbrModal.vue